import { Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/AppShell';
import { RequireAdmin, RequireAuth, RequireSuperAdmin } from '@/components/RequireRole';
import { AdminChallengeViewPage } from '@/pages/AdminChallengeViewPage';
import { AdminDashboardPage } from '@/pages/AdminDashboardPage';
import { ChallengeDetailPage } from '@/pages/ChallengeDetailPage';
import { CreateChallengePage } from '@/pages/CreateChallengePage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { FriendsPage } from '@/pages/FriendsPage';
import { HomePage } from '@/pages/HomePage';
import { LeaderboardPage } from '@/pages/LeaderboardPage';
import { LockedAccountsPage } from '@/pages/LockedAccountsPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { NotificationsPage } from '@/pages/NotificationsPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { SignupPage } from '@/pages/SignupPage';
import { TermsPage } from '@/pages/TermsPage';
import { VerifyEmailPage } from '@/pages/VerifyEmailPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />

      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/challenge/:id" element={<ChallengeDetailPage />} />
        <Route path="/create" element={<CreateChallengePage />} />
        <Route path="/explore" element={<LeaderboardPage />} />
        <Route path="/friends" element={<FriendsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/:userId" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboardPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/challenge/:id"
          element={
            <RequireAdmin>
              <AdminChallengeViewPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/admin/locked-accounts"
          element={
            <RequireSuperAdmin>
              <LockedAccountsPage />
            </RequireSuperAdmin>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
